import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from 'components/Common/Modals/Dialog'
import TechListPreview from 'components/Common/TechListPreview'
import { Container, FakeBlock, LoaderWrapper, ButtonsWrapper } from './_styles'
import DownloadButton from './DownloadButton'
import ShareButton from './ShareButton'
import Loader from 'components/Common/Loader'
import ShareModal from './ShareModal'

const TechListPreviewDesktop = props => {
  const { data, loading, close, isDownloading, download, lng, printRef } = props
  const { t } = useTranslation()

  const [isShareModalOpened, setShareModalOpened] = useState(false)

  return (
    <>
      <Dialog.Wrapper>
        <Container>
          <Dialog.Header
            title={t('wine.view.previewTechlistModal.header')}
            onClose={close}
          />
          <Dialog.Content>
            {loading ? (
              <LoaderWrapper>
                <Loader color='#3B42A5' size='30px' />
              </LoaderWrapper>
            ) : (
              <TechListPreview
                product={data}
                lng={lng}
                actions={
                  <ButtonsWrapper>
                    <ShareButton
                      data-testid='wine-public-techsheet-share-button'
                      onClick={() => setShareModalOpened(true)}
                    />
                    <DownloadButton
                      data-testid='wine-public-techsheet-download-button'
                      onClick={() => download(printRef, data?.slug)}
                      loading={isDownloading}
                    />
                  </ButtonsWrapper>
                }
              />
            )}
          </Dialog.Content>
          <FakeBlock />
        </Container>
      </Dialog.Wrapper>

      {isShareModalOpened && (
        <ShareModal toggleModal={() => setShareModalOpened(false)} />
      )}
    </>
  )
}

export default TechListPreviewDesktop
